module.exports = __webpack_public_path__ + "img/googlePlay.0bcbc3bc.png";